import { useEffect, useState } from 'react';
import { fetchOrganizationalCulture } from '../utils/organizationalCultureAPI';

export default function OrganizationalCulture() {
  const [item, setItem] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchOrganizationalCulture()
      .then((next) => {
        if (!cancelled) setItem(next);
      })
      .catch(() => {
        if (!cancelled) setError('פירוט התרבות לא נטען כרגע.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section id="culture" className="gl-culture">
      <div className="gl-section-head">
        <p className="gl-kicker">Great Leaders</p>
        <h2>
          תרבות ארגונית.
          <span>שמונת החלקים של החברה.</span>
        </h2>
      </div>

      {loading ? <p className="gl-culture-status">טוען את התרבות…</p> : null}
      {error ? <p className="gl-culture-status">{error}</p> : null}

      {item ? (
        <div className="gl-culture-detail">
          {(item.sections || []).map((section) => (
            <article key={section.id}>
              <h4>{section.titleHe}</h4>
              <p className="gl-culture-summary">{section.summaryHe}</p>
              <dl>
                {(section.fields || []).map((field) => (
                  <div key={field.key}>
                    <dt>{field.labelHe}</dt>
                    <dd>{field.text || 'טרם מולא'}</dd>
                  </div>
                ))}
              </dl>
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
